














































































import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import LabeledValue from '@/components/LabeledValue.vue'
import axios from 'axios'
import { Barcode, BarcodeMapper, PriceList, PriceListEntry } from 'serverless-firestore'
import DynamsoftBarcodeScanner from '@/components/Barcode/DynamsoftBarcodeScanner.vue'
import CategorySelectionModal from '@/components/Order/CategorySelectionModal.vue'
import compatibility from '@/services/compatibility.service'

@Component({
  components: {
    DynamsoftBarcodeScanner,
    LabeledValue,
    LoadingPage,
    CategorySelectionModal
  }
})
export default class VendorBarcodeScanDialog extends Mixins(IconsMixin, AuthMixin) {
  @Prop({ type: Boolean, default: false })
  public show!: boolean

  public showScanner = true

  @Prop({ type: Object, default: null })
  public priceList!: PriceList

  public details: Barcode | null = null
  public upc: string | null = null
  public description: string | null = null

  public lookingUpBarcode: boolean = false
  public invalidLastScan: boolean | null = null
  public invalidLastScanTimeout: number | null = null

  public formValid: boolean = false

  public getUserMedia = compatibility.getUserMedia

  public $refs!: {
    barcodeScanner: DynamsoftBarcodeScanner
    description: HTMLInputElement
  }

  @Emit()
  public hide() {}

  @Emit('added')
  public async addToPriceList() {
    if (!this.details || !this.upc || !this.description) {
      return
    }

    const entry = new PriceListEntry(this.upc, this.description)
    entry.barcode = this.details
    entry.category = this.details.category

    await this.reset()
    return entry
  }

  @Watch('show')
  public onShowChange(show: boolean) {
    if (!show) {
      this.showScanner = false
      // @ts-ignore
      this.$refs.barcodeScanner.stopScanning()
    } else if (this.$refs.barcodeScanner) {
      this.showScanner = true
      // @ts-ignore
      this.$refs.barcodeScanner.startScanning()
    }
  }

  public async onScannedBarcode(upc: string) {
    this.showScanner = false

    const barcode = await this.lookupBarcodeUsingRemoteDB(upc)

    this.upc = upc
    if (barcode) {
      this.details = barcode
      this.description = barcode.name
    } else {
      this.details = new Barcode()
      this.invalidScan()
    }

    this.$nextTick(() => { this.$refs.description.focus() })
  }

  public async reset() {
    this.details = null
    this.upc = null
    this.description = null
    this.showScanner = true

    // @ts-ignore
    await this.$refs.barcodeScanner.resetScanner()
  }

  protected invalidScan() {
    this.invalidLastScan = true
    if (this.invalidLastScanTimeout) {
      clearTimeout(this.invalidLastScanTimeout)
    }

    this.invalidLastScanTimeout = window.setTimeout(() => {
      this.invalidLastScan = false
      this.invalidLastScanTimeout = null
    }, 2000)
  }

  protected async lookupBarcodeUsingRemoteDB(upc: string): Promise<Barcode | null> {
    this.lookingUpBarcode = true
    try {
      return ( new BarcodeMapper() ).map(( await axios.get(`/api/barcode/${ upc }`) ).data)
    } catch (e) {
      return null
    } finally {
      this.lookingUpBarcode = false
    }
  }
}
